import { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, FormControl, Input, InputLabel, MenuItem, OutlinedInput, Select, } from '@mui/material';

import calculateEnabledStatus from '../utils/calculateEnabledStatus';

QuestionnaireChoiceMultiple.propTypes = {
  element: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func,
  values: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function QuestionnaireChoiceMultiple(props) {
  const { element, setFieldValue, values, readOnly } = props;

  const [notDisabled, setNotDisabled] = useState(true);

  const currentValue = useMemo(() => values[element.linkId] || [], [element.linkId, values]);

  useEffect(() => {
    if (element.enableBehavior) {
      const enableStatus = calculateEnabledStatus(element.enableBehavior, element.enableWhen, values);
      setNotDisabled(enableStatus !== undefined && enableStatus);
    }
  }, [element.enableBehavior, element.enableWhen, values]);

  const handleChange = useCallback((e) => {
    setFieldValue(element.linkId, e.target.value || '');
  }, [setFieldValue, element.linkId]);

  return (
    <FormControl sx={{ width: '100%' }}>
      <InputLabel>{element.required ? `${element.text}*` : element.text}</InputLabel>
      <Select
        multiple
        disabled={!notDisabled}
        value={currentValue}
        onChange={handleChange}
        variant={readOnly ? "standard" : "outlined"}
        inputProps={{ readOnly }}
        input={readOnly ?
          (<Input label={element.required ? `${element.text}*` : element.text} />) :
          (<OutlinedInput label={element.required ? `${element.text}*` : element.text} />)}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {element.answerOption?.map((option) => (
          <MenuItem key={option.valueCoding?.code} value={option.valueCoding?.code}>
            {option.valueCoding?.display}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

  );
}

export default QuestionnaireChoiceMultiple;
